import { useNavigate } from 'react-router-dom';
import { theme } from '../theme';

// Botón reutilizable que lleva a la vista de "Ver links" (/mis-links),
// donde están los enlaces que el negocio debe entregar a sus clientes.
function VerLinksButton({ style }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/mis-links')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 20px',
        backgroundColor: theme.colors.primary,
        color: theme.colors.background,
        border: 'none',
        borderRadius: '8px',
        fontSize: '0.92rem',
        fontWeight: 700,
        cursor: 'pointer',
        boxShadow: `0 4px 16px ${theme.colors.glowStrong}`,
        ...style,
      }}
    >
      🔗 Ver los links que le debo entregar a mis clientes
    </button>
  );
}

export default VerLinksButton;
